import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'

export const PasteHandler = Extension.create({
  name: 'pasteHandler',

  addProseMirrorPlugins() {
    const editor = this.editor
    const pasteFunctions = {
      transformPasted: {
        default: (slice) => {
          const frag = slice.content
          frag.forEach((node) => {
            node.content.forEach((item) => {
              // strip inline styles only - keep other marks (bold, link, etc.)
              item.marks = item.marks.filter(
                (mark) => mark.type?.name !== 'textStyle',
              )
            })
          })

          return slice
        },

        paste_without_formatting: (slice) => {
          // strip tables here; deal with sanitising after content is pasted:
          // see editor transaction event handler
          return pasteFunctions.transformPasted.paste_from_email(slice)
        },

        paste_from_email: (slice) => {
          // strip tables
          const sanitisedSlice = pasteFunctions.transformPasted.default(slice)
          const frag = sanitisedSlice.content
          frag.forEach((node) => {
            if (node.type?.name === 'table') {
              node.attrs.unset = true
            }
          })

          return slice
        },
      },
    }

    editor.on('transaction', ({ editor, transaction }) => {
      const pasteOption = editor?.options?.editorProps?.attributes?.pasteOption

      if (transaction.meta?.paste && !!pasteOption) {
        if (pasteOption === 'paste_without_formatting') {
          editor
            .chain()
            .focus()
            .selectAll()
            // sanitise the content (remove marks)
            .unsetAllMarks()
            // uncomment `.clearNodes()` to strip all nodes out (headings, etc.)
            .clearNodes()
            .run()
        }

        // reset paste option to default
        EventBus.$emit('editorEventPaste')
      }
    })

    return [
      new Plugin({
        key: new PluginKey('pasteHandler'),
        props: {
          // all Prosemirror plugins: https://prosemirror.net/docs/ref/#view.EditorProps
          transformPasted(slice, view) {
            const pasteOption =
              editor?.options?.editorProps?.attributes?.pasteOption || 'default'
            return pasteFunctions.transformPasted[pasteOption](slice, view)
          },
        },
      }),
    ]
  },
})
